export default [
  {
    name: "1-0",
    section: 1.0,
    start: 0,
    end: 15, // 15
    duration: 15,
  },
  {
    name: "1-1",
    section: 1.1,
    start: 15,
    end: 39.57, // 39
    duration: 24,
  },
  {
    name: "1-2",
    section: 1.2,
    start: 39.57,
    end: 96.7, // 98
    duration: 59,
  },
  {
    name: "1-3",
    section: 1.3,
    start: 98,
    end: 142,
    duration: 44,
  },
  {
    name: "2-0",
    section: 2.0,
    start: 142,
    end: 166.2,
    duration: 25,
  },
  {
    name: "2-1",
    section: 2.1,
    start: 167,
    end: 188.9,
    duration: 22,
  },
  {
    name: "2-2",
    section: 2.2,
    start: 189,
    end: 205,
    duration: 16,
  },
  {
    name: "2-3",
    section: 2.3,
    start: 205,
    end: 220.9,
    duration: 17,
  },
  {
    name: "2-4",
    section: 2.4,
    start: 222,
    end: 234,
    duration: 13,
  },
  {
    name: "2-5",
    section: 2.5,
    start: 235,
    end: 254,
    duration: 19,
  },
  {
    name: "3-0",
    section: 3.0,
    start: 254,
    end: 282.7,
    duration: 30,
  },
  {
    name: "3-1",
    section: 3.1,
    start: 284,
    end: 341.3,
    duration: 58,
  },
  {
    name: "3-2",
    section: 3.2,
    start: 342,
    end: 372,
    duration: 30,
  },
  {
    name: "4-0",
    section: 4.0,
    start: 372,
    end: 390,
    duration: 18,
  },
  {
    name: "4-1",
    section: 4.1,
    start: 390,
    end: 411,
    duration: 21,
  },
  {
    name: "4-2",
    section: 4.2,
    start: 411,
    end: 427.3,
    duration: 17,
  },
  {
    name: "4-3",
    section: 4.3,
    start: 428,
    end: 450,
    duration: 24,
  },
  {
    name: "5-0",
    section: 5.0,
    start: 452,
    end: 474.5,
    duration: 23,
  },
  {
    name: "5-1",
    section: 5.1,
    start: 475,
    end: 511,
    duration: 37,
  },
  {
    name: "5-2",
    section: 5.2,
    start: 512,
    end: 539.2,
    duration: 28,
  },
  {
    name: "5-3",
    section: 5.3,
    start: 539.5,
    end: 573,
    duration: 33,
  },
  {
    name: "6-0",
    section: 6.0,
    start: 574.4,
    end: 591.9,
    duration: 19,
  },
  {
    name: "6-1",
    section: 6.1,
    start: 593.5,
    end: 638,
    duration: 46,
  },
  {
    name: "6-2",
    section: 6.2,
    start: 639.5,
    end: 679,
    duration: 41,
  },
  {
    name: "7-0",
    section: 7.0,
    start: 638,
    end: 638,
    duration: 41,
  },
  {
    name: "7-1",
    section: 7.1,
    start: 0,
    end: 14.7, // 15
    duration: 15,
  },
];
